import * as jsxRuntime from "/Users/nebolsin/src/vstage/virtual_lobby/packages/client/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment